import { render, staticRenderFns } from "./AddressListLeft.vue?vue&type=template&id=10c96479&scoped=true"
import script from "./AddressListLeft.vue?vue&type=script&lang=js"
export * from "./AddressListLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c96479",
  null
  
)

export default component.exports